export default __webpack_public_path__ + "static/media/steps__slider-main-item-icon-little-6.4cc567b6.svg";